<div class="saved-articles-card" (click)="navigate()">
    {{ label }}
    <ion-icon name="bookmark"></ion-icon>
</div>
